/** Design tokens from solution-stories.html */
export const STORY_UI = {
  bg: '#FFFFFF',
  surface: '#FFFFFF',
  surfaceSunken: '#F2F7FF',
  ink: '#000000',
  inkSoft: '#232324',
  inkFaint: '#999999',
  line: '#E6E6E6',
  lineStrong: '#C9DEFF',
  accent: '#0064FF',
  accentDeep: '#0051CB',
  accentTint: '#E4EFFF',
  heroBg: '#F2F7FF',
  navy: '#002659',
  navy2: '#003583',
  sky: '#3685FF',
  skyLight: '#79ADFF',
  radiusLg: '20px',
  radiusMd: '14px',
  radiusSm: '9px',
  radiusPill: '100px',
  shadowCard: '0 1px 2px rgba(0,0,0,0.04), 0 8px 24px -12px rgba(0,0,0,0.10)',
  shadowPop: '0 4px 8px rgba(0,0,0,0.05), 0 32px 64px -20px rgba(0,0,0,0.28)',
  fontSans: "'Inter', sans-serif",
  fontDisplay: "'Space Grotesk', sans-serif",
  fontMono: "'IBM Plex Mono', monospace",
} as const;

export const STAGE_ORDER = ['won', 'signed', 'delivered', 'renewed'] as const;
export type StoryStage = (typeof STAGE_ORDER)[number];

/** Customer Journey bar at top of detail modal (no Renewed step). */
export const JOURNEY_ORDER = ['won', 'signed', 'delivered'] as const;
export type JourneyStage = (typeof JOURNEY_ORDER)[number];

export const STAGE_LABEL: Record<StoryStage, string> = {
  won: 'Won',
  signed: 'Signed',
  delivered: 'Delivered',
  renewed: 'Renewed',
};

export const STAGE_BADGE_SX: Record<StoryStage, { bg: string; color: string }> = {
  won: { bg: '#E4EFFF', color: '#003583' },
  signed: { bg: '#C9DEFF', color: '#002659' },
  delivered: { bg: '#0064FF', color: '#FFFFFF' },
  renewed: { bg: '#002659', color: '#FFFFFF' },
};

export const EXAMPLE_QUERIES = [
  'Manufacturing projects on Google Cloud',
  'Banking case studies',
  'BigQuery migration',
] as const;
